/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Zalify has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
(function (w) {
  w.getExpectTime = function (day_number) {
    try {
      let date = new Date();
      date.setDate(date.getDate() + day_number);
      function zeroFill(i) {
        if (i >= 0 && i <= 9) {
          return "0" + i;
        } else {
          return i;
        }
      }
      const month = zeroFill(date.getMonth() + 1);
      const day = zeroFill(date.getDate());
      let englist_month = "Jan.";
      if (month == "02") {
        englist_month = "Feb.";
      } else if (month == "03") {
        englist_month = "Mar.";
      } else if (month == "04") {
        englist_month = "Apr.";
      } else if (month == "05") {
        englist_month = "May.";
      } else if (month == "06") {
        englist_month = "Jun.";
      } else if (month == "07") {
        englist_month = "Jul.";
      } else if (month == "08") {
        englist_month = "Aug.";
      } else if (month == "09") {
        englist_month = "Sept.";
      } else if (month === 10) {
        englist_month = "Oct.";
      } else if (month === 11) {
        englist_month = "Nov.";
      } else if (month === 12) {
        englist_month = "Dec.";
      }
      const curTime = englist_month + day;
      console.log(curTime, "getExpectTime");
      return curTime;
    } catch (error) {
      console.log(error);
    }
  };

  w.customAddToCartEvent = function (product) {
    /* pinterest*/
    // pintrk("track", "addtocart", {
    //   value: product.original_price,
    //   order_quantity: 1,
    //   currency: Shopify.currency.active || "USD",
    //   line_items: [
    //     {
    //       product_name: product.name,
    //       product_id: product.id,
    //       product_price: product.original_price,
    //       product_quantity: product.quantity,
    //     },
    //   ],
    // });
  };
  /* add to cart event */
  const originalFetch = window.fetch;
  w.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    if (args[0].includes("/cart/add.js")) {
      const responseClone = response.clone();
      try {
        const data = await responseClone.json();
        w.customAddToCartEvent(data);
      } catch (error) {
        console.error("Failed to parse response:", error);
      }
    }
    return response;
  };

  document.addEventListener("DOMContentLoaded", () => {
    /* menu click event */
    document.addEventListener('click', function(e) {
      const menuLink = e.target.querySelector('span.header__linklist-link');
      if (menuLink) {
        const menuId = menuLink.getAttribute('data-aria-controls');
        if (!menuId) return;
        const isExpanded = menuLink.getAttribute('data-aria-expanded') === 'true';
        document.querySelectorAll('.header__linklist-link[data-aria-expanded="true"]').forEach(item => {
          if (item !== menuLink) {
            item.setAttribute('data-aria-expanded', 'false');
            const itemMenu = document.getElementById(item.getAttribute('data-aria-controls'));
            if (itemMenu) itemMenu.hidden = true;
          }
        });
        menuLink.setAttribute('data-aria-expanded', !isExpanded);
        const targetMenu = document.getElementById(menuId);
        if (targetMenu) {
          targetMenu.hidden = isExpanded;
        }
        return;
      }
      if (!e.target.closest('.header__linklist-item')) {
        document.querySelectorAll('.header__linklist-link[data-aria-expanded="true"]').forEach(item => {
          item.setAttribute('data-aria-expanded', 'false');
          const menu = document.getElementById(item.getAttribute('data-aria-controls'));
          if (menu) menu.hidden = true;
        });
      }
    });

    /* product detail */
    const button = document.querySelector(".product-form__accordion button");
    if (button) {
      button.click();
    } else {
      console.warn("Button not found");
    }
  });

  /* breadcrumb */
  try {
    const referer = document.referrer;
    const refererHandle = referer.split('/collections/');
    const allProductsDom = document.querySelector('.breadcrumb__item[data-breadcrumb-handle="all-products"]');
    if(refererHandle.length > 1) {
      const targetDom = document.querySelector('.breadcrumb__item[data-breadcrumb-handle='+ refererHandle[1] +']');
      if(targetDom) {
        targetDom.style.display = 'flex';
      }else{
        !!allProductsDom && (allProductsDom.style.display = 'flex')
      }
    }else{
      !!allProductsDom && (allProductsDom.style.display = 'flex')
    }
    document.querySelector('.breadcrumb').style.visibility = 'visible'
  }catch (e) {
    console.log(e);
  }
  
})(window);
